import './LinkertoProCard.css';
import { useState } from 'react';
import { Button, Card, CardContent, CircularProgress, Typography } from '@mui/material';
import { FaCheck } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'context/AuthContext';
import { useToast } from 'context/ToastContext';
import apiClient from 'services/apiService';

const LinkertoProCard = () => {
    const { t } = useTranslation();
    const { user, setNotifications } = useAuth();
    const { showToast } = useToast();
    const [loading, setLoading] = useState(false);

    const features: string[] = t('dashboard.main.proCard.features', { returnObjects: true }) as string[];
    const notifySignedUp = user?.notifications?.proRelease === true;

    const handleNotifyClick = async () => {
        if (loading || notifySignedUp) return;
        setLoading(true);
        try {
            const res = await apiClient.patch('/user/notifications', { proRelease: true });
            setNotifications(res.data.notifications);
        } catch {
            showToast('error', t('settings.billing.notify-error'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card variant="outlined" className='dashboard-card pro'>
            <CardContent className='pro-card-content'>
                <div className='pro-card-header'>
                    <Typography variant="body1" component="p" className='pro-card-title'>
                        {t('dashboard.main.proCard.title')}
                    </Typography>
                    <Typography variant="body2" className='pro-card-badge'>
                        {t('dashboard.main.proCard.badge')}
                    </Typography>
                </div>

                <div className='pro-card-body'>
                    <Typography variant="body2" className='pro-card-description'>
                        {t('dashboard.main.proCard.description')}
                    </Typography>
                    <ul className='pro-card-features'>
                        {features.map((feature, i) => (
                            <li key={i}>
                                <Typography variant="body2">{feature}</Typography>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className='pro-card-footer'>
                    <Button
                        variant={notifySignedUp ? 'text' : 'outlined'}
                        size="large"
                        className='pro-card-cta'
                        onClick={handleNotifyClick}
                        disabled={loading || notifySignedUp}
                        startIcon={
                            loading
                                ? <CircularProgress size={16} color="inherit" />
                                : notifySignedUp
                                    ? <FaCheck size={12} />
                                    : null
                        }
                    >
                        {notifySignedUp
                            ? t('dashboard.main.proCard.cta-subscribed')
                            : t('dashboard.main.proCard.cta')}
                    </Button>
                </div>
            </CardContent>
        </Card>
    );
};

export default LinkertoProCard;
